module.exports = __webpack_public_path__ + "static/media/instagramLogo.d189ef79.png";